<section class="alert-banner" [ngClass]="alertConfig.bgClass" [ngStyle]="alertConfig.bgColor ? { 'background-color': alertConfig.bgColor } : null">
  <article class="alert-banner__icon">
    <ts-icon
      [icon]="alertConfig.iconName"
      [ngClass]="alertConfig.iconColorClass"
    ></ts-icon>
  </article>
  <article class="alert-banner__text" [ngClass]="alertConfig.textColorClass">
    <ng-content></ng-content>
  </article>
</section>
